import { Card, Empty, Progress, Tag, Typography } from "antd"
import React from "react"
import { Link } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { budgetFormat } from "../../../../utils/number/budget-format.ts"
import { normalizePercent } from "../../../Projects/constants/helpers.ts"
import { getProgressColor } from "../../../Projects/constants/project-progress.ts"
import { PROJECT_STATUSES_MAP } from "../../../Projects/constants/project-statuses.ts"
import type { ProjectSnapshot } from "./_helpers.ts"

interface ProjectSnapshotSectionProps {
  title: string
  emptyText: string
  budgetLabel: string
  nextMilestoneLabel: string
  snapshots: ProjectSnapshot[]
}

export const ProjectSnapshotSection = ({
  title,
  emptyText,
  budgetLabel,
  nextMilestoneLabel,
  snapshots
}: ProjectSnapshotSectionProps) => (
  <section data-testid={"mobile-home-snapshot"}>
    <Typography.Title level={5} className={"!mb-2"}>
      {title}
    </Typography.Title>

    {snapshots.length === 0 ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
    ) : (
      <div className={"flex gap-2 overflow-x-auto pb-1 snap-x"}>
        {snapshots.map((snapshot) => {
          const percent = normalizePercent(snapshot.progress)
          const status = PROJECT_STATUSES_MAP?.[snapshot.status]

          return (
            <Link
              key={snapshot.id}
              to={RoutesPaths.project.view(snapshot.id).overview}
              className={"shrink-0 basis-[80%] snap-start"}
            >
              <Card size={"small"} className={"h-full"}>
                <Typography.Text strong ellipsis className={"block"}>
                  {snapshot.name}
                </Typography.Text>

                {status ? (
                  <Tag style={status.style} className={"mt-1"} bordered={false}>
                    {status.label}
                  </Tag>
                ) : null}

                <Progress
                  percent={percent}
                  size={"small"}
                  strokeColor={getProgressColor(percent)}
                />

                <Typography.Text type={"secondary"} className={"block text-xs"}>
                  {budgetLabel}: {budgetFormat(snapshot.budget ?? null)}
                </Typography.Text>

                {snapshot.nextMilestone ? (
                  <Typography.Text
                    type={"secondary"}
                    className={"block text-xs"}
                  >
                    {nextMilestoneLabel}: {snapshot.nextMilestone}
                  </Typography.Text>
                ) : null}
              </Card>
            </Link>
          )
        })}
      </div>
    )}
  </section>
)
